import React from 'react';
import { Link } from 'react-router-dom';
import dateFormat from 'dateformat';
import { isJobActive, setClassForStatusBubble } from '../../../../utils/helpers';
import styles from './appliedJobTableItem.module.scss';

function AppliedJobTableItem(props) {
  const { item } = props;

  return (
    <tr key={item.Job?.Id}>
      <td>
        <Link
          to={`/dashboard/jobs/${item?.Job?.Id}${window.location.search}`}
          style={isJobActive(item) ? null : { pointerEvents: 'none' }}
        >
          {item?.Job?.Id}
        </Link>
      </td>
      <td>{item.Job?.JobTitle}</td>
      <td>{item.Job?.JobType}</td>
      <td>{item.Job?.Industry}</td>
      <td>{item.Job?.Location}</td>
      <td>{dateFormat(item?.CreatedDate, 'dd mmm yyyy')}</td>
      <td className={styles.statusColumn}>
        <div className={`${styles.tags} ${setClassForStatusBubble(item?.JobApplicationStatus?.UIName, styles)}`}>
          {item?.JobApplicationStatus?.UIName}
        </div>
      </td>
    </tr>
  );
}

export default AppliedJobTableItem;
